import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import BillingInfoModalsWrapper from '../../components/HistoryComps/BillingInfoComps/BillingInfoModalsWrapper';
import ShowAllBillingInfo from '../../components/HistoryComps/BillingInfoComps/ShowAllBillingInfo';
import BillingHistoryProvider from '../../contexts/BillingHistoryProvider';
import MutationModalProvider from '../../contexts/MutationModalProvider';

const BillingInfo = () => {
  // rendering billing info page component here
  return (
    <>
      <PageTitle title='Billing History' />

      <BillingHistoryProvider>
        <MutationModalProvider>
          <ShowAllBillingInfo />
          <BillingInfoModalsWrapper />
        </MutationModalProvider>
      </BillingHistoryProvider>
    </>
  );
};

export default BillingInfo;
